<template>
  <q-dialog :visible="isVisible" :title="title" width="830px" :innerScroll="false" :showFooter="false" @close="onCancel">
    <el-table
      :data="tableData.records"
      ref="tableRef"
      border
      :height="288"
      :header-cell-style="{ textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }"
      v-loading="loading"
    >
      <el-table-column label="序号" prop="index" min-width="50px" align="center"></el-table-column>
      <el-table-column label="操作人" prop="createdBy" min-width="80px"></el-table-column>
      <el-table-column label="操作时间" prop="createdDate" min-width="200px"></el-table-column>
      <el-table-column label="变更前" prop="beforeModify" min-width="100" show-overflow-tooltip></el-table-column>
      <el-table-column label="变更后" prop="afterModify" min-width="100" show-overflow-tooltip></el-table-column>
      <el-table-column label="更新字段" prop="modifyField" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column label="更新行" prop="fieldDesc" min-width="80" show-overflow-tooltip></el-table-column>
    </el-table>
    <div style="text-align: right; margin-top: 10px">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="tableData.pageNum"
        :page-sizes="[10, 20, 30]"
        :page-size="tableData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableData.total"
      >
      </el-pagination>
    </div>
  </q-dialog>
</template>

<script>
export default {
  name: "CRUDEdit",
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "历史记录";
    },
  },
  data() {
    return {
      loading: false,
      addForm: {
        rowData: [],
      },
      rules: {},
      tableData: {
        pageNum: 1,
        pageSize: 10,
        records: [],
        total: 0,
      },
    };
  },
  mounted() {
    this.$set(this.addForm, "rowData", this.rowData);
  },
  methods: {
    init() {
      this.loading = true;
      let data = {
        dataType: "61",
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
      };
      this.$q.newProduct
        .modifyInfoSearch({ data: data })
        .then((res) => {
          this.tableData = res.data;
          this.tableData.records = res.data.records.map((v, index) => {
            return {
              ...v,
              index: (index + 1) + ((this.tableData.pageNum -1) * 10),
            };
          });
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    onCancel() {
      this.isVisible = false;
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>

.content {
  max-height: 70vh
  overflow-y: auto
}

>>> .el-dialog {
  margin: 50px auto !important
}
.right {
  text-align: right
}
.center {
  text-align: center
}
.row-height {
  height: 28px
  margin-top: 20px;
  line-height: 28px
}
 .el-select >>> .el-input {
   width: 360px
 }
</style>
